import { useEffect } from "react";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: Record<string, unknown>[];
  }
}

/**
 * Global click listener that fires Google Ads conversion + GTM dataLayer event
 * whenever a user clicks any tel: link on the site.
 */
export const usePhoneCallTracking = () => {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const anchor = (e.target as HTMLElement).closest?.("a[href^='tel:']");
      if (!anchor) return;

      const phoneNumber = (anchor as HTMLAnchorElement).href.replace("tel:", "");

      // Push event to dataLayer for GTM
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "phone_call_click",
        phone_number: phoneNumber,
        click_url: window.location.href,
      });

      // Fire Google Ads conversion event directly via gtag
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
          send_to: "AW-17392224142/phone_call_click",
          value: 1.0,
          currency: "USD",
        });
      }
    };

    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, []);
};
